import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Chart.js 기본 요소 등록
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const NewMultiAxisLineChart = ({list}) => {
    const salesData = Array(24).fill(0);
    const orderCountData = Array(24).fill(0);
    const cancelData = Array(24).fill(0);

    list.forEach(item => {
        const hourIndex = item.hour; // 월 값에 맞춰 인덱스 설정
        salesData[hourIndex] = item.totalSalesAmount || 0;
        orderCountData[hourIndex] = item.completeOrderCount || 0;
        cancelData[hourIndex] = item.cancelOrderCount || 0;
    });

    // orderCountData에서 최고값 찾기
    const maxOrderCount = Math.max(...orderCountData);

    // 인기 문구 추가된 라벨 생성
    const labels = ['0시', '1시', '2시', '3시', '4시', '5시', '6시', '7시', '8시', '9시', '10시', '11시', '12시', '13시', '14시', '15시', '16시', '17시', '18시', '19시', '20시', '21시', '22시', '23시'];
    const labelsText = labels.map((_, index) => orderCountData[index] === maxOrderCount && maxOrderCount !== 0);

    // 데이터 설정
    const data = {
        labels: labels,
        datasets: [
            {
                label: '총 매출액',
                data: salesData,
                borderColor: 'rgba(0, 204, 204, 1)',
                backgroundColor: 'rgba(0, 204, 204, 1)',
                yAxisID: 'y', // 왼쪽 축
            },
            {
                label: '총 주문건수',
                data: orderCountData,
                borderColor: 'rgba(0, 146, 255, 1)',
                backgroundColor: 'rgba(0, 146, 255, 1)',
                yAxisID: 'y1', // 오른쪽 축
            },
            {
                label: '주문취소',
                data: cancelData,
                borderColor: 'rgba(51, 51, 51, 0)',
                backgroundColor: 'rgba(51, 51, 51, 0)'
            }
        ]
    };

    // 옵션 설정
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false
            },
        },
        scales: {
            x: {
                display: false, // x축 라벨 숨김
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                min: 0,
                max: 500000,
                ticks: {
                    callback: function(value) {
                        return value / 10000 + '만'; // 백만 단위로 포맷
                    },
                    stepSize:50000,
                    maxTicksLimit: 11
                },
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                min: 0,
                max: 50,
                grid: {
                    drawOnChartArea: false, // 왼쪽 축의 그리드와 구분
                },
                ticks: {
                    callback: function(value) {
                        return value + '건'; // 백만 단위로 포맷
                    },
                    stepSize:5,
                    maxTicksLimit: 11
                },
            },
        },
    };

    return (
        <>
            <Line data={data} options={options} />
            <ul className="chartUl d-flex a-end j-between">
                {labelsText.map((value, index) => {
                    return (
                        <li className={`fs-14 fw-5 ta-center ${value ? "red" : ""}`} key={index}>
                            {value &&
                              <p className="fs-12 fw-4">인기</p>
                            }
                            {index}시
                        </li>
                    )
                })}
            </ul>
        </>
    );
};

export default NewMultiAxisLineChart;
